import { useTranslation } from "react-i18next";
import { ChangeEvent, useCallback, useState, useEffect } from "react";
import Button from "components/common/Button/Button";
import InputsContainer from "components/common/InputsContainer/InputsContainer";
import { TimePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import {
  IExpeditionModesDialog,
  IExpeditionModesEditingDataError,
} from "./EditExpeditionMode.types";
import { useSnackBar } from "hooks/useSnackBar";
import TextInput from "components/common/TextInput/TextInput";
import {
  useGetExpeditionModeByIdQuery,
  useUpdateExpeditionModeMutation,
} from "redux/api/delivery/expeditionMode/expeditionMode";
import { InputStyleCostMode } from "../ExpeditionModeAdd/AddExpeditionMode.style";
import Table from "components/common/Table/Table";
import {
  Autocomplete,
  FormControl,
  Grid,
  Select,
  SelectChangeEvent,
  TextField,
} from "@mui/material";
import { AutoInputsContainerStyle } from "features/Product/ProductAdd/Product.style";
import { RouteIdEnum } from "config/enums";
import DashboardLayout from "layouts/DashboardLayout/DashboardLayout";
import { useNavigate, useParams } from "react-router-dom";
import useTaxList from "features/Taxe/TaxeList/useTaxList";
import { useGetAllExpeditionCategsQuery } from "redux/api/delivery/expeditionCategs/expeditionCategs";
function EditExpeditionMode({ codeInfos }: IExpeditionModesDialog) {
  const { t } = useTranslation();
  const { id }: any = useParams();
  console.log(id)
  const { data: allCategs } = useGetAllExpeditionCategsQuery({ all: true });
  const { data: editingData } = useGetExpeditionModeByIdQuery({
    id: id,
  });
  console.log("***************editingData***********",editingData)
  const navigate = useNavigate();
  const [editingInfo, setEditingInfo] = useState<any>({
    start: "",
    end: "",
    tax_value: "",
    shipping_tax:"",
  });
  const { taxesData } = useTaxList();
  let CategValueArray = editingInfo?.categ_value?.map((categ: any) => ({
    category: categ.category,
    price: categ.price,
  }));
  console.log(editingInfo)
  const baseCategories: any[] = Array.isArray(allCategs?.data)
    ? allCategs?.data
    : Array.isArray(allCategs)
    ? allCategs
    : [];
  const sortedCategories = [...baseCategories].sort((a, b) => {
    const nameA = (a?.category_shipping?.name || a?.name || "").toLowerCase();
    const nameB = (b?.category_shipping?.name || b?.name || "").toLowerCase();
    return nameA.localeCompare(nameB);
  });
  const { displaySuccessSnackBar, displayErrorApiSnackBar } = useSnackBar();
  const [editingError, setEditingError] =
    useState<IExpeditionModesEditingDataError>({
      title: "",
      start: "",
      end: "",
      tax_value: "",
      type: 0,
      categ_value: "",
    });
  const onChange = useCallback(
    (field: string) =>
      (value: string | ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        const newValue = typeof value === "string" ? value : value.target.value;
        setEditingInfo({ ...editingInfo, [field]: newValue });
      },
    [editingInfo]
  );

  const onSelectChange = useCallback(
    (field: string) => (event: SelectChangeEvent<string>) => {
      const value = Number(event.target.value);
      setEditingInfo({ ...editingInfo, [field]: value });
    },
    [editingInfo, editingError]
  );
  useEffect(() => {
    if (editingData) {
      setEditingInfo({ 
        ...editingData,
        // keep whatever categ_value the API returns if any; otherwise start empty
        categ_value: editingData?.categ_value || [],
        tax_value: editingData.tax_value || "",
        shipping_tax: editingData.shipping_tax || "",
      });
    }
  }, [editingData]);

  const [editingCode, { data, error, reset }] =
    useUpdateExpeditionModeMutation();

  if (error) {
    displayErrorApiSnackBar(error);
    reset();
  }
  if (data) {
    displaySuccessSnackBar(t("delivery.successfully_editing_mod"));

    reset();
    navigate(-1);
  }
  const onChangeCategValue = useCallback(
    (categoryId: string) =>
      (e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        const idNum = parseInt(categoryId);
        const priceVal = e.target.value;
        setEditingInfo((prevState: any) => {
          const next = { ...prevState } as any;
          const current: any[] = Array.isArray(next.categ_value)
            ? [...next.categ_value]
            : [];
          const idx = current.findIndex((it) => it.category == idNum);
          if (idx >= 0) {
            current[idx] = { ...current[idx], category: idNum, price: priceVal };
          } else {
            current.push({ category: idNum, price: priceVal });
          }
          next.categ_value = current;
          return next;
        });
      },
    []
  );

  const validate = () => {
    const editingDataErrorMode: any = {
      title: "",
      start: "",
      end: "",
      tax_value: "",
      type: "",
      categ_value: "",
    };
    if (editingInfo.title == "") {
      editingDataErrorMode.title = "Mode obliagtoire";
    } else {
      editingDataErrorMode.title = "";
    }
    if (editingInfo.start == "") {
      editingDataErrorMode.start = "Date debut obliagtoire";
    } else {
      editingDataErrorMode.start = "";
    }
    if (editingInfo.tax_value == "") {
      editingDataErrorMode.tax_value = "Taxe obliagtoire";
    } else {
      editingDataErrorMode.tax_value = "";
    }
    if (editingInfo.end == "") {
      editingDataErrorMode.end = "Date fin obliagtoire";
    } else {
      editingDataErrorMode.end = "";
    }
    if (!editingInfo.categ_value) {
      editingDataErrorMode.categ_value =
        "Valeurs categorie d'expédition obliagtoire";
    } else {
      editingDataErrorMode.categ_value = "";
    }
    if (editingInfo.type == null) {
      editingDataErrorMode.type = "type obliagtoire";
      alert("ok");
    } else {
      editingDataErrorMode.type = "";
    }
    console.log("editingdataError", editingDataErrorMode);
    setEditingError(editingDataErrorMode);
  };

  const onSuccessEditingDialog = (event: React.FormEvent) => {
    event.preventDefault();
    validate();

    if (
      editingInfo.title &&
      editingInfo.start &&
      editingInfo.end &&
      editingInfo.tax_value
    ) {
      editingCode({ ...editingInfo });
    }
  };

  return (
    <DashboardLayout
      title={t("delivery.edit_mod")}
      selectedPath={RouteIdEnum.Expedition_Mode}
      backPath={RouteIdEnum.Expedition_Mode}
    >
      <InputsContainer title={t("delivery.info_add")}>
        <Grid container spacing={1}>
          <AutoInputsContainerStyle item xs={12} md={12} lg={6}>
            <FormControl fullWidth>
              <Select
                native
                value={editingInfo?.type?.toString()}
                onChange={onSelectChange("type")}
                label={t("delivery.type")}
                sx={{
                  borderColor: "#B269AE",
                }}
              >
                <option value="1">Lolo Drive</option>
                <option value="0">Livraison</option>
              </Select>
            </FormControl>
          </AutoInputsContainerStyle>

          <AutoInputsContainerStyle item xs={12} md={12} lg={6}>
            <TextInput
              value={editingInfo?.title}
              label={t("delivery.mode")}
              onChange={onChange("title")}
              error={t(editingError.title)}
            />
          </AutoInputsContainerStyle>

          <AutoInputsContainerStyle item xs={12} md={12} lg={6}>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <TimePicker
                label={t("delivery.start_time")}
                value={
                  editingInfo.start ? dayjs(editingInfo.start, "HH:mm") : null
                }
                onChange={(newValue) => {
                  onChange("start")(newValue ? newValue.format("HH:mm") : "");
                }}
                ampm={false}
                sx={{ width: "100%" }}
                slotProps={{
                  textField: {
                    error: Boolean(t(editingError.start)),
                    helperText: t(editingError.start),
                  },
                }}
              />
            </LocalizationProvider>
          </AutoInputsContainerStyle>

          <AutoInputsContainerStyle item xs={12} md={12} lg={6}>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <TimePicker
                label={t("delivery.end_time")}
                value={editingInfo.end ? dayjs(editingInfo.end, "HH:mm") : null}
                onChange={(newValue) => {
                  onChange("end")(newValue ? newValue.format("HH:mm") : "");
                }}
                ampm={false}
                sx={{ width: "100%" }}
                slotProps={{
                  textField: {
                    error: Boolean(t(editingError.end)),
                    helperText: t(editingError.end),
                  },
                }}
              />
            </LocalizationProvider>
          </AutoInputsContainerStyle>

          <AutoInputsContainerStyle item xs={12} md={12} lg={6}>
            {taxesData && (
              <Autocomplete
                sx={{ width: "100%" }}
                options={taxesData?.data?.map((tax: any) => ({
                  id: tax.id,
                  name: tax.name,
                  percentage: tax.percentage,
                })).sort((a: any, b: any) => a.name.localeCompare(b.name))}
                getOptionLabel={(option: any) =>
                  option?.name ? `${option.name} (${option.percentage}%)` : ""
                }
                value={
                  taxesData?.data?.find(
                    (tax: any) =>
                      tax.percentage === editingInfo?.tax_value
                  ) || null
                }
                onChange={(event: any, newValue: any) => {
                  const newTaxValue = newValue ? newValue.percentage : "";
                  setEditingInfo((prev: any) => ({
                    ...prev,
                    tax_value: newTaxValue,
                    shipping_tax: newValue ? newValue.id : "",
                  }));
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label={t("delivery.tax")}
                    variant="outlined"
                    placeholder={t("delivery.select_tax")}
                    error={Boolean(t(editingError.tax_value))}
                    helperText={t(editingError.tax_value)}
                  />
                )}
              />
            )}
          </AutoInputsContainerStyle>
        </Grid>
      </InputsContainer>

      <InputsContainer title={t("delivery.categories")}>
        <Grid container spacing={1} marginTop={2}>
          <hr />

          <Table
            loader={false}
            headerData={[
              {
                key: "category",
                title: t("delivery.category"),
              },
              {
                key: "value",
                title: t("delivery.value"),
              },
            ]}
            bodyData={sortedCategories?.map((categ: any) => {
              return {
                category: (
                  <p>{categ?.category_shipping?.name || categ?.name || ""}</p>
                ),
                value: (
                  <InputStyleCostMode>
                    <TextInput
                      value={
                        (
                          (editingInfo?.categ_value || []).find(
                            (cv: any) =>
                              cv.category ==
                              (categ?.category_shipping?.id || categ?.id)
                          )?.price ?? "0"
                        ).toString()
                      }
                      type="number"
                      min={0}
                      defaultValue={0}
                      onChange={onChangeCategValue(
                        `${categ?.category_shipping?.id || categ?.id}`
                      )}
                    />
                  </InputStyleCostMode>
                ),
              };
            })}
          />
        </Grid>
      </InputsContainer>

      <Grid container spacing={1} style={{ justifyContent: "flex-end" }}>
        <AutoInputsContainerStyle item xs={4} md={4} lg={2}>
          <Button
            type="submit"
            onClick={(e: any) => onSuccessEditingDialog(e)}
            title={t("delivery.edit_mod")}
          />
        </AutoInputsContainerStyle>
      </Grid>
    </DashboardLayout>
  );
}

export default EditExpeditionMode;
